import { Action, createReducer, on } from '@ngrx/store';
import {
  getUsersActivityLogStatsAction, getUsersActivityLogStatsSuccessAction, getUsersActivityLogStatsFailureAction,
} from './get-users-activity-log-stats.actions';
import { GetUsersActivityLogStatsState } from './get-users-activity-log-stats.types';

const initialState = {
  loading: false,
  loaded: false,
  data: null,
  error: null,
};

const getUsersActivityLogStatsReducer = createReducer<GetUsersActivityLogStatsState>(
  initialState,
  on(
    getUsersActivityLogStatsAction,
    state => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),
  on(
    getUsersActivityLogStatsSuccessAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      data: action.data,
      error: null,
    })
  ),
  on(
    getUsersActivityLogStatsFailureAction,
    (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      data: null,
      error: action.error,
    })
  ),
);

export const reducer = (state: GetUsersActivityLogStatsState, action: Action) => getUsersActivityLogStatsReducer(state, action);
